import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from '@services';
import { fieldRequired, markFormGroupTouched } from '@utils';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-nfe-dados-declaracao',
  templateUrl: './nfe-dados-declaracao.component.html',
  styleUrls: ['./nfe-dados-declaracao.component.css']
})
export class NfeDadosDeclaracaoComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalDadosDeclaracao', { static: true }) modalDadosDeclaracao;
  loading = [];

  form = new FormGroup({
    // Para simplificar, no momento vamos implementar só uma declaração e uma adição, que é o caso mais comum.
    ndi: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(15)]),
    ddi: new FormControl(null, [Validators.required]),
    xLocDesemb: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(60)]),
    ufDesemb: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
    dDesemb: new FormControl(null, [Validators.required]),
    tipoViaTransporte: new FormControl(null, [Validators.required]),
    valorAFRMM: new FormControl(null, [Validators.min(0.0), Validators.max(9999999999999.99)]),
    formaImportacao: new FormControl(null, [Validators.required]),
    clienteID: new FormControl(null),
    cExportador: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(60)]),
    nAdicao: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(3)]),
    nSeqAdic: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(5)]),
    cFabricante: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(60)]),
    vDescDI: new FormControl(0, [Validators.min(0.0), Validators.max(9999999999999.99)]),
    nDraw: new FormControl(null, [Validators.maxLength(20)]),
  });

  listaTipoViaTransporte = [
    { value: 1, label: '1 - Marítima' },
    { value: 2, label: '2 - Fluvial' },
    { value: 3, label: '3 - Lacustre' },
    { value: 4, label: '4 - Aérea' },
    { value: 5, label: '5 - Postal' },
    { value: 6, label: '6 - Ferroviária' },
    { value: 7, label: '7 - Rodoviária' },
    { value: 8, label: '8 - Conduto/Rede Transmissão' },
    { value: 9, label: '9 - Meios Próprios' },
    { value: 10, label: '10 - Entrada/Saída Ficta' },
    { value: 11, label: '11 - Courier' },
    { value: 12, label: '12 - Em mãos' },
    { value: 13, label: '13 - Por reboque' },
  ];
  listaFormaImportacao = [
    { value: 1, label: '1 - Importação por conta própria' },
    { value: 2, label: '2 - Importação por conta e ordem' },
    { value: 3, label: '3 - Importação por encomenda' },
  ];

  constructor(
    private messageService: MessageService,
  ) {
    super();
  }

  ngOnInit() {
  }

  show(props) {
    this.modalDadosDeclaracao.show();

    this.loading['salvar'] = false;
    this.form.reset({
      vDescDI: 0
    });

    this.form.get('tipoViaTransporte').valueChanges.subscribe(res => {
      if (res === 1) {
        // Marítima, AFRMM é obrigatório
        this.form.get('valorAFRMM').addValidators(Validators.required);
      } else {
        this.form.get('valorAFRMM').removeValidators(Validators.required);
      }
      this.form.get('valorAFRMM').updateValueAndValidity();
    });

    this.form.get('formaImportacao').valueChanges.subscribe(res => {
      if (res === 2 || res === 3) {
        // Conta e Ordem ou Encomenda
        this.form.get('clienteID').addValidators(Validators.required);
      } else {
        this.form.get('clienteID').removeValidators(Validators.required);
      }
      this.form.get('clienteID').updateValueAndValidity();
    });

    if (props?.dados?.length > 0) {
      const di = props.dados[0];
      this.form.get('ndi').setValue(di.ndi);
      this.form.get('ddi').setValue(di.ddi);
      this.form.get('xLocDesemb').setValue(di.xLocDesemb);
      this.form.get('ufDesemb').setValue(di.ufDesemb);
      this.form.get('dDesemb').setValue(di.dDesemb);
      this.form.get('cExportador').setValue(di.cExportador);
      this.form.get('tipoViaTransporte').setValue(di.tipoViaTransporte);
      this.form.get('valorAFRMM').setValue(di.valorAFRMM);
      this.form.get('formaImportacao').setValue(di.formaImportacao);
      this.form.get('clienteID').setValue(di.clienteID);

      if (di.adicoes?.length > 0) {
        const adicao = di.adicoes[0];
        this.form.get('nAdicao').setValue(adicao.nAdicao);
        this.form.get('nSeqAdic').setValue(adicao.nSeqAdic);
        this.form.get('cFabricante').setValue(adicao.cFabricante);
        this.form.get('vDescDI').setValue(adicao.vDescDI);
        this.form.get('nDraw').setValue(adicao.nDraw);
      }
    }
  }

  cancelar() {
    this.closed.emit(null);
  }

  salvar() {
    markFormGroupTouched(this.form);
    if (!this.form.valid) {
      this.messageService.error('Verifique os campos obrigatórios.', 5000);
      return;
    }

    this.loading['salvar'] = true;

    const dados = this.form.getRawValue();
    this.closed.emit([{
      ndi: dados.ndi,
      ddi: dados.ddi,
      xLocDesemb: dados.xLocDesemb,
      ufDesemb: dados.ufDesemb,
      dDesemb: dados.dDesemb,
      cExportador: dados.cExportador,
      tipoViaTransporte: dados.tipoViaTransporte,
      valorAFRMM: dados.valorAFRMM,
      formaImportacao: dados.formaImportacao,
      clienteID: dados.clienteID,
      adicoes: [
        {
          nAdicao: dados.nAdicao,
          nSeqAdic: dados.nSeqAdic,
          cFabricante: dados.cFabricante,
          vDescDI: dados.vDescDI || 0,
          nDraw: dados.nDraw,
        },
      ],
    }]);
  }

  fieldRequired(campo) {
    return fieldRequired(this.form, campo);
  }
}
